/**
 * Walk a cursor-paginated list endpoint, yielding items one at a time across
 * pages. Follows `pagination.next_cursor` until `has_more` is false (or a cursor
 * is missing). `fetchPage` receives the cursor to request (undefined for page 1).
 */
export async function* paginate(fetchPage) {
    let cursor;
    for (;;) {
        const page = await fetchPage(cursor);
        for (const item of page.data) {
            yield item;
        }
        const p = page.pagination;
        if (p && p.has_more && p.next_cursor) {
            cursor = p.next_cursor;
        }
        else {
            return;
        }
    }
}
//# sourceMappingURL=pagination.js.map